import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { PageSkeleton } from "../../../components/loading/PageSkeleton";
import { Container } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "0 !important",
    margin: "0 auto",
  },
}));

const ActivityWrapper = () => {
  const s = useStyles();
  return (
    <Container maxWidth={"lg"} className={s.container}>
      <Suspense
        fallback={
          <PageSkeleton
            fullWidth
            style={{
              marginBlock: 64,
              paddingInline: 24,
            }}
          />
        }
      >
        <Outlet />
      </Suspense>
    </Container>
  );
};

export default ActivityWrapper;
